<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [isBlur]="isBlur"
  [errors]="question.errors"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [type]="question.controlType"
  [dirty]="dirty"
  [formGroup]="formGroup"
  [display]="question.display"
  [type]="question.type"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>

<ng-container [formGroup]="formGroup">
  <input
    type="hidden"
    [id]="'date-picker' + question.key"
    [value]="displayValue"
    [formControlName]="question.key"
  />
  <ion-item
    (click)="onInputClick()"
    [id]="'date-picker-item-' + question.key"
    [ngClass]="displayValue ? 'item-with-value' : 'item-no-value'"
  >
    {{ displayValue ? displayValue : (question.placeholder | translate) }}
    <ion-modal
      size="cover"
      alignment="center"
      [keepContentsMounted]="true"
      (ionModalDidPresent)="onDateTimeModalDidPresent()"
      (ionModalWillDismiss)="onDateTimeModalWillDismiss()"
    >
      <ng-template>
        <ion-content>
          <ion-datetime
            #datetime
            [presentation]="presentation"
            mode="ios"
            [locale]="userLocale"
            [value]="pickerCurrentDate"
            [max]="question.max"
            [min]="question.min"
            [attr.disabled]="question.disabled"
            [attr.readonly]="question.readonly"
            [cancelText]="question.cancelText | translate"
            [doneText]="question.doneText | translate"
            [clearText]="'CLEAR' | translate"
            [hourCycle]="hourCycle"
            showDefaultButtons="true"
            showClearButton="true"
            (ionFocus)="onFocus()"
            (ionBlur)="onBlur()"
            (ionChange)="onChange($event.detail.value)"
            (ionConfirm)="onConfirm($event.detail.value)"
            (ionCancel)="onCancel()"
            (ionClear)="onClear()"
            [class.datetime-ready]="isDateTimeReady()"
          >
            <span slot="title"> {{ question.label }}</span>
          </ion-datetime>
        </ion-content>
      </ng-template>
    </ion-modal>
  </ion-item>
</ng-container>
